  const viewMoreElement = document.querySelector('.js-btn-load-more');

  if (viewMoreElement) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
          if (entry.isIntersecting) {
            viewMoreElement.click();
          }
      });
    });
    observer.observe(viewMoreElement);
  }
// const viewMoreElement = document.querySelector('.js-btn-load-more');

// if (viewMoreElement) {
//   const observer = new IntersectionObserver(
//     (entries) => {
//       entries.forEach((entry) => {
//         // Trigger when 25% of button is visible
//         if (entry.intersectionRatio >= 0.25) {
//           viewMoreElement.click();
//         }
//       });
//     },
//     {
//       threshold: 0.25
//     }
//   );

//   observer.observe(viewMoreElement);
// }